import React from 'react';

import { ReactProps } from '../../typings/common-types';

import Icon, { IconProps } from './icon';

const svg = (props: ReactProps) => (
  <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...props}>
    <path fill="currentColor" d="M0 60h80L40 20z" fillRule="evenodd" />
  </svg>
);

const IconArrowUp: React.FC<IconProps> = (props: ReactProps) => <Icon {...props} svg={svg} />;

export default IconArrowUp;
